module.exports = __webpack_public_path__ + "47ffcd8160335c10da608dd9da492eb8.svg";